import { boot } from "quasar/wrappers";
import axios from "axios";

export default boot(({ app }) => {
  const api = axios.create();
  api.defaults.baseURL = process.env.API;
  // api.defaults.headers.common["apitoken"] = process.env.API_KEY;
  app.config.globalProperties.$axios = axios;
  app.config.globalProperties.$api = api;
});

const api = axios.create();
api.defaults.baseURL = process.env.API;
// api.defaults.headers.comon["apitoken"] = process.env.API_KEY;

export { api };
